import { Navigate, useParams } from "react-router-dom";
import { FactDetails } from "../components/FactDetails";
import { PageHeader } from "../components/PageHeader";
import { verifiedFacts } from "../data/verifiedFacts";

export function FactDetailsPage() {
  const { factId } = useParams();
  const fact = verifiedFacts.find((item) => item.id === factId);
  if (!fact) return <Navigate to="/facts" replace />;

  return (
    <div className="page page--narrow">
      <PageHeader eyebrow="Подтверждённый факт" title={fact.title} description="Проверьте статус и источник перед использованием." back />
      <FactDetails fact={fact} />
    </div>
  );
}
